import { NEW_NOTIFICATION } from "../../store/modules/notifications/constants.js";

export const notificationMixin = {
  methods: {
    successNotification(message) {
      this.$store.dispatch(NEW_NOTIFICATION, {
        message,
        priority: "success"
      });
    },
    warningNotification(message) {
      this.$store.dispatch(NEW_NOTIFICATION, {
        message,
        priority: "warning"
      });
    },
    errorNotification(message) {
      this.$store.dispatch(NEW_NOTIFICATION, { message, priority: "error" });
    }
  }
};
